<!-- Header -->
<h1 mat-dialog-title>{{ element.name }}</h1>

<!-- Content -->
<div mat-dialog-content>
  <editor [(ngModel)]="element.value" [init]="TinyMCEConfig"></editor>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'">
    <mat-icon>save</mat-icon>
    {{ 'save' | translate }}
  </button>

</div>
